/*###########################################################################
// App
//#########################################################################*/

/* CSS
//------------------*/

import "@css/app.css";

/* App
//------------------*/

window.app = {
  _scrollLocks: 0,
  disableScroll() {
    this._scrollLocks += 1
    document.documentElement.style.overflow = 'hidden'
  },
  enableScroll() {
    this._scrollLocks = Math.max(0, this._scrollLocks - 1)
    if (this._scrollLocks === 0) {
      document.documentElement.style.overflow = ''
    }
  },
}


/* Components
//------------------*/

import '@js/components/index'

/* Vendor
//------------------*/

import '@js/vendor/index'

/**
 * Alpine JS + Swup
 * Swup must start before Alpine mutates the DOM (cache safety).
*/
import Alpine from 'alpinejs';
import { initSpaNav } from '@js/components/_spaNav';
import { initAccountPages } from '@js/components/_accountPages';
import { registerAddCardPicker, bindAddCardTriggers } from '@js/components/_addCardPicker';
import { registerBinder } from '@js/components/_binder';
import { registerDecks } from '@js/components/_decks';
import { registerChaseHoloCard } from '@js/components/_holoCard';
import { showConfirm, showPrompt, bindConfirmLinks } from '@js/components/_confirmDialog';
import { initFavoriteAlerts } from '@js/components/_favoriteAlerts';
import { initDeckImportFlyout } from '@js/components/_deckImportFlyout';
import { registerWalkthrough, dispatchPendingWalkthroughSignal } from '@js/components/_walkthrough';

initSpaNav();
initFavoriteAlerts();
initDeckImportFlyout();
bindConfirmLinks();

window.Alpine = Alpine;
window.showSiteConfirm = showConfirm;
window.showSitePrompt = showPrompt;
registerAddCardPicker(Alpine);
registerBinder(Alpine);
registerDecks(Alpine);
registerChaseHoloCard(Alpine);
registerWalkthrough(Alpine);
Alpine.start();
initAccountPages();
bindAddCardTriggers();
dispatchPendingWalkthroughSignal();

/**
 * Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
 */
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log("HMR");
  });
}
